<template>
  <footer id="app-footer">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-4 col-md-5 col-sm-12 text-center">
          <h3>Social</h3>
          <ul class="social-links">
            <li>
              <a href="https://twitter.com/TEDxOsakaU" target="_blank">
                Twitter
              </a>
            </li>
            <li>
              <a href="https://www.facebook.com/TEDxOsakaU" target="_blank">
                Facebook
              </a>
            </li>
          </ul>
        </div>

        <div class="col-lg-4 col-md-5 col-sm-12 text-center">
          <h3>Feel free to contact us!</h3>
          <div class="contact-info">
            tedxosakau(at)gmail.com<br/>
            (at)を@に変えて送ってください。
          </div>
        </div>

        <div class="col-12">
          <p class="app-copyright text-center">
            &copy; TED CONFERENCES, LLC Some Rights Reserved | TEDxOsakaU<br />
            <span>Designed and Made by <a href="http://hayashikun.com" target="_blank">Ryosuke Hayashi</a></span>
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
};
</script>

<style lang="scss" scoped>
@import "../assets/global";

#app-footer {
  background: $brand-darker;
  padding: 20px 0 0 0;
  width: 100%;
  margin: 24px 0 0 0;

  @include media-breakpoint-down(sm) {
    padding: 8px 6px;
  }

  h3 {
    color: rgba($brand-white, .9);
    text-transform: uppercase;
    font-size: 18px;
    margin: 2px 0 4px 0;

    @include media-breakpoint-down(sm) {
      margin: 12px 0 2px 0;
    }
  }

}

.social-links {
  list-style: none;
  margin: 0;
  padding: 0;

  a {
    color: rgba($brand-white, .8);
  }
}

.contact-info {
  color: rgba($brand-white, .8);
}

.app-copyright {
  color: rgba($brand-white, .8);
  margin: 24px 0 16px 0 !important;
  width: 100%;
  a {
    font-weight: bold;
    color: rgba($brand-white, .9);
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Footer.vue